import { render, staticRenderFns } from "./member_ai_study.vue?vue&type=template&id=0d024204&scoped=true"
import script from "./member_ai_study.vue?vue&type=script&lang=js"
export * from "./member_ai_study.vue?vue&type=script&lang=js"
import style0 from "./member_ai_study.vue?vue&type=style&index=0&id=0d024204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d024204",
  null
  
)

export default component.exports